import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import Emitter from '@utils/eventEmitter'

export const getAbsentee = createAsyncThunk('GET_ABSENTEE', async () => {
  let options = {
    method: 'GET',
    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/manager/absentee`
  }
  let response = await apiRequest(options)
  if (response.__isError) { return }
  return response
})

export const saveAbsentee = createAsyncThunk('SAVE_ABSENTEE', async (data) => {
  let options = {
    method: 'POST',
    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/manager/absentee`,
    data
  }
  let response = await apiRequest(options)
  if (response.__isError) { return }
  return data
})

export const deleteAbsentee = createAsyncThunk('DELETE_ABSENTEE', async () => {
  let options = {
    method: 'DELETE',
    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/manager/absentee`
  }
  let response = await apiRequest(options)
  if (response.__isError) { return }
  return true
})

const absenteeSlice = createSlice({
  name: 'absentee',
  initialState: {
    absenteeInfo: null,
    isLoading: false,
    isSuccess: false,
  },
  reducers: {
    clearIsSuccess: (state) => {
      state.isSuccess = false
    },
    clearIsLoading: (state) => {
      state.isLoading = false
    }
  },
  extraReducers: {
    [getAbsentee.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }
      state.absenteeInfo = payload
    },
    [saveAbsentee.pending]: (state) => {
      state.isLoading = true
    },
    [saveAbsentee.rejected]: (state) => {
      state.isLoading = false
    },
    [saveAbsentee.fulfilled]: (state, { payload }) => {
      state.isLoading = false

      if (!payload) {
        return
      }

      Emitter.emit('SHOW_MESSAGE', {
        text: `등록되었습니다.`
      })
    },
    [deleteAbsentee.pending]: (state) => {
      state.isLoading = true
    },
    [deleteAbsentee.rejected]: (state) => {
      state.isLoading = false
    },
    [deleteAbsentee.fulfilled]: (state, { payload }) => {
      state.isLoading = false

      if (!payload) {
        return
      }

      state.absenteeInfo = null

      Emitter.emit('SHOW_MESSAGE', {
        text: `등록취소 되었습니다.`
      })
    },
  }
})

export const { clearIsSuccess, clearIsLoading } = absenteeSlice.actions

export default absenteeSlice.reducer
